import { ArrowUp } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="footer" className="relative bg-ink border-t border-white/10 overflow-hidden">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 pt-16 pb-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16">
          <div>
            <p className="font-display text-3xl text-white" style={{ fontWeight: 800 }}>
              PURSUIT <span className="text-signal">MEDIA</span>{" "}
              <span className="font-mono text-[10px] tracking-[0.35em] text-smoke align-middle ml-2">
                STUDIOS
              </span>
            </p>
            <p className="font-mono text-[10px] tracking-[0.3em] text-smoke mt-3">
              AUTOMOTIVE &amp; MOTORSPORT — VIDEO / PHOTO / FILM
            </p>
          </div>
          <button
            data-testid="back-to-top-button"
            onClick={() => window.__lenis?.scrollTo(0, { duration: 1.6 })}
            className="group flex items-center gap-3 font-mono text-[11px] tracking-[0.25em] text-white/70 hover:text-signal transition-colors"
          >
            BACK TO TOP
            <span className="w-10 h-10 border border-white/20 flex items-center justify-center group-hover:border-signal transition-colors">
              <ArrowUp size={15} className="group-hover:-translate-y-0.5 transition-transform" />
            </span>
          </button>
        </div>

        <div
          className="font-display text-outline text-center leading-none select-none text-[clamp(4rem,18vw,17rem)] -mb-6 md:-mb-10"
          style={{ fontWeight: 900 }}
          aria-hidden
        >
          PURSUIT
        </div>

        <div className="relative flex flex-col md:flex-row items-center justify-between gap-2 border-t border-white/10 pt-6 font-mono text-[10px] tracking-[0.25em] text-white/40">
          <span>© 2026 PURSUIT MEDIA STUDIOS</span>
          <span>SHOT ON LOCATION — NO RE-TAKES</span>
        </div>
      </div>
    </footer>
  );
}
